export const validNameSurname = (value) => {
    const regEx = new RegExp('^(?:[a-zA-ZñÑáéíóúÁÉÍÓÚüÜÇç àâçéèêëîïôûùüÿñæœÀÂÇÉÈÊËÎÏÔÛÙÜŸÑÆŒs\'-]+)$');
    if (!value)
        return true;
    return regEx.test(value);
};
